"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _locales = _interopRequireDefault(require("../../i18n/locales"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var LocalizationProvider = function LocalizationProvider(WrappedComponent) {
  var renderer = function renderer(props) {
    var locale = props.locale;

    var renderProps = _objectSpread({}, props);

    delete renderProps['locale'];
    var messages = _locales["default"][locale] || {};
    return (
      /*#__PURE__*/
      _react["default"].createElement(_reactIntl.IntlProvider, {
        locale: locale,
        messages: messages
      },
      /*#__PURE__*/
      _react["default"].createElement(WrappedComponent, renderProps))
    );
  };

  renderer.propTypes = _objectSpread({
    locale: _propTypes["default"].string
  }, WrappedComponent.propTypes);
  renderer.defaultProps = {
    locale: 'en'
  };
  renderer.displayName = "LocalizationProvider(".concat(getDisplayName(WrappedComponent), ")");
  return renderer;
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

var _default = LocalizationProvider;
exports["default"] = _default;